module.exports = __webpack_public_path__ + "img/1_54.d23db094.png";